
export default {
  name: 'CookieCustomizationModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isModalOpen: false,
      cookiePreferences: {
		technical: true,
		analytics: false,
		profiling: false
      }
    }
  },
  methods: {
    close() {
      this.isModalOpen = false;
      this.$emit('close');
    },
    savePreferences() {
      this.$session.set('cookie_preferences', this.cookiePreferences);
      this.$session.set('cookie_accepted', true);
      
      this.$emit('preferences-saved', this.cookiePreferences);
      
      this.close();
    }
  },
  watch: {
    isOpen(val) {
      this.isModalOpen = val;
      if (val) {
        const existingPrefs = this.$session.get('cookie_preferences');
        if (existingPrefs) {
          this.cookiePreferences = { ...existingPrefs };
        }
      }
    }
  }
}
